import React from "react";
import styled from "@emotion/styled";
import PencilIconGraphic from "@ecologi/assets/icons/Buttons/pencil.svg";
import CloseIconGraphic from "@ecologi/assets/icons/close-icon.svg";
import TickIconGraphic from "@ecologi/assets/icons/tick.svg";
import PlusIconGraphic from "@ecologi/assets/icons/plus-icon.svg";

const StyledCloseIcon = styled(CloseIconGraphic)`
  fill: ${(props) => props.theme.colors.scarlet};
`;

const StyledTickIcon = styled(TickIconGraphic)`
  fill: ${(props) => props.theme.colors.jungleDark};
`;

const StyledPencilIcon = styled(PencilIconGraphic)`
  fill: ${(props) => props.theme.colors.charcoal};
`;

const StyledPlusIcon = styled(PlusIconGraphic)`
  width: 12px;
  height: 12px;
  fill: ${(props) => props.theme.colors.charcoal};
`;

export const CloseIcon = React.memo(StyledCloseIcon);
export const TickIcon = React.memo(StyledTickIcon);
export const PencilIcon = React.memo(StyledPencilIcon);
export const PlusIcon = React.memo(StyledPlusIcon);
